const parseNumber = (stringNumber) =>
  stringNumber !== null ? Number(stringNumber.split(',').join('')) : null;

export default parseNumber;
